//import { get } from 'lodash';
// import { contentPages as cK } from 'src/tools/contentModulesFieldName';
import { generateTabContent } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import arrayMove from 'array-move';

const useContentTab = () => {
  const handleOnModalConfirm = (value, onChange, newContent, index) => {
    const nV = (value || []).map((d, i) => {
      if (i === index) {
        return newContent;
      } else {
        return d;
      }
    });
    onChange(nV);
  };
  const handleOnAdd = (value, onChange, data) => {
    //const pc = generateNewContentPage();
    //const { pc } = ;
    onChange([...(value || []), data]);
  };

  const handleOnAddTab = (value, onChange, data) => {
    onChange([...(value || []), generateTabContent(data + 1)]);
  };
  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  return {
    handleOnModalConfirm,
    handleOnAdd,
    handleOnDelete,
    handleOnSort,
    handleOnAddTab,
  };
};
export { useContentTab };
